import { Box, Card, CardContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ApiFetchImage } from "utils/ApiCall";
import profileImg from "../../../assets/imgs/profile_img.svg";

export default function MarketplaceResidentBanner({ residentId, residentName, roomNumber, bed, showPhoto }) {
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    if (!showPhoto || !residentId || +residentId === 0) {
      setPhoto(null);
      return;
    }

    let isActive = true;
    setPhoto(null);

    ApiFetchImage(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_BASE_URL}/Residents/Photo/${residentId}`
    )
      .then((res) => {
        if (!isActive || !res) {
          if (isActive) setPhoto(null);
          return;
        }
        const reader = new FileReader();
        reader.onload = function () {
          if (isActive) setPhoto(reader.result);
        };
        reader.readAsDataURL(res);
      })
      .catch(() => {
        if (isActive) setPhoto(null);
      });

    return () => {
      isActive = false;
    };
  }, [residentId, showPhoto]);

  return (
    <Card
      sx={{
        boxShadow: ".125rem .25rem .25rem .0625rem rgba(0, 0, 0, .35) !important",
      }}
    >
      <CardContent
        sx={{
          padding: ".5rem .75rem !important",
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          backgroundColor: "#3e6281",
          borderRadius: ".5rem",
        }}
      >
        <Box
          component="img"
          src={photo || profileImg}
          alt={residentName ? `${residentName} profile` : "profile"}
          sx={{
            width: "3.5rem",
            height: "3.5rem",
            borderRadius: "50%",
            objectFit: photo ? "cover" : "none",
            backgroundColor: "#4e7291",
            flexShrink: 0,
          }}
        />
        <Box display="flex" justifyContent="flex-start" alignItems="space-between" flexWrap="wrap">
          <Box width="100%">
            <Typography
              variant="h6"
              sx={{
                color: "#fff",
                fontWeight: "bold",
                textTransform: "uppercase",
                lineHeight: 1.2,
              }}
            >
              {residentName}
            </Typography>
          </Box>
          <Box mt="1rem" display="flex">
            {roomNumber && (
              <Box>
                <Typography variant="subtitle2" sx={{ color: "#fff", fontWeight: "bold" }}>
                  {`ROOM: ${roomNumber}`}
                </Typography>
              </Box>
            )}
            {bed && (
              <Box ml={roomNumber ? "2rem" : "0"}>
                <Typography variant="subtitle2" sx={{ color: "#fff", fontWeight: "bold" }}>
                  {`BED: ${bed}`}
                </Typography>
              </Box>
            )}           
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
